/**
 * Hook for managing anonymous chat persistence in sessionStorage
 * Uses discrete key '_sw_cid' to store chatId for anonymous users
 */

const CHAT_ID_KEY = '_sw_cid';

export const useAnonymousChat = () => {
  const getStoredChatId = (): string | null => {
    try {
      return sessionStorage.getItem(CHAT_ID_KEY);
    } catch (error) {
      console.warn('Failed to access sessionStorage:', error);
      return null;
    }
  };

  const setStoredChatId = (chatId: string): void => {
    try {
      sessionStorage.setItem(CHAT_ID_KEY, chatId);
    } catch (error) {
      console.warn('Failed to set sessionStorage:', error);
    }
  };

  const clearStoredChatId = (): void => {
    try {
      sessionStorage.removeItem(CHAT_ID_KEY);
    } catch (error) {
      console.warn('Failed to clear sessionStorage:', error);
    }
  };

  return { getStoredChatId, setStoredChatId, clearStoredChatId };
};
